import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {Segment} from 'semantic-ui-react';
import TopLevel from './TopLevel';
import _ from 'lodash';
import {DYNAMIC_DATA_GET_ENTITY_SUCCESS, DYNAMIC_DATA_GET_SUCCESS} from 'common/types';
import SideNavInternal from 'go/components/dynamic/layout/SideNavInternal';
import {isSubApplicationConfig} from 'go/components/dynamic/modules/grantLandingPage/utils';

export class ApplicationNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checking: true,
      shouldLoad: false,
      hasBeenExpanded: false,
    };
  }

  componentDidMount() {
    let {token, grantId, config, subGrantId} = this.props;
    const {configType} = config;
    const activePage = isSubApplicationConfig(configType)
      ? 'subApplication'
      : 'application';
    this.props
      .getConfig(activePage)
      .then((res) => {
        if (activePage === 'subApplication') {
          return this.props.getSubApplication(token, subGrantId);
        } else {
          return this.props.getApplication(token, grantId);
        }
      })
      .then((res) => {
        if (
          (res.type === DYNAMIC_DATA_GET_SUCCESS ||
            res.type === DYNAMIC_DATA_GET_ENTITY_SUCCESS) &&
          !_.isEmpty(res.payload)
        ) {
          this.setState({
            shouldLoad: true,
          });
        }
        this.setState({
          checking: false,
        });
      })
      .catch((err) => {
        console.log(
          `Config or Application could not be retrieved for grantId: ${grantId}.`,
          err
        );
        this.setState({
          checking: false,
        });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isActive !== this.props.isActive) {
      this.setState({
        hasBeenExpanded: true,
      });
    }
  }

  setActivePage(configName) {
    this.props.loadPageWithConfig(configName);
  }

  render() {
    const {baseClass, isActive, config} = this.props;
    const {configType} = config;
    const reportName = isSubApplicationConfig(configType)
      ? 'Subapplication'
      : 'Application';

    const activePage = isSubApplicationConfig(configType)
      ? 'subApplication'
      : 'application';
    const APPLICATION_REPORT_NAME = reportName;
    if (this.state.checking) {
      return (
        <Segment tertiary inverted>
          Checking for Application...
        </Segment>
      );
    } else if (this.state.shouldLoad) {
      return (
        <React.Fragment>
          <TopLevel
            name={APPLICATION_REPORT_NAME}
            baseClass={baseClass}
            handleClick={() => this.setActivePage(activePage)}
            active={isActive}
            isExpandable={false}
          />
          {isActive && config && (
            <React.Fragment>
              <SideNavInternal
                navToSpecificLocation={() => {
                  /* this is the key to making the sidenav active state work
                          don't use until figuring out how to incorporate VisibilitySensor into this
                        */
                }}
                location={this.props.location}
                title={'Application Navigation'}
                {...config.payload}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getApplication: (token, grantId) => {
    const action = ApiActions.dynamicData.getDataByGrant(token, grantId, 'application');
    const res = dispatch(action);
    return res;
  },
  getSubApplication: (token, subGrantId) => {
    const action = ApiActions.dynamicData.getDataByEntityId(token, subGrantId);
    const res = dispatch(action);
    return res;
  },
});

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationNavItem);
